import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Hero.css";
import bgImage from "../assets/bg.png";

const NAV_CARDS = [
  { label: "About Me",       desc: "My story, background & interests",  icon: "👤", to: "/about",        accent: "teal"   },
  { label: "Resume",         desc: "Download my full résumé",           icon: "📄", to: "/resume",       accent: "purple" },
  { label: "Education",      desc: "Academic background & coursework",  icon: "🎓", to: "/education",    accent: "blue"   },
  { label: "Projects",       desc: "Work I've built & shipped",         icon: "🛠️", to: "/projects",     accent: "amber"  },
  { label: "Achievements",   desc: "Academic honors & recognitions",    icon: "🏆", to: "/achievements", accent: "lime"   },
  { label: "Competitions",   desc: "Hackathons, contests & challenges", icon: "⚡", to: "/competitions", accent: "orange" },
  { label: "Leadership",     desc: "Orgs, clubs & roles I've held",     icon: "🧭", to: "/leadership",   accent: "sky"    },
  { label: "Certificates",   desc: "Seminars, webinars & credentials",  icon: "🎖️", to: "/certificates", accent: "pink"   },
  { label: "Skills",         desc: "Languages, tools & technologies",   icon: "💡", to: "/skills",       accent: "green"  },
  { label: "Contact",        desc: "Let's connect & collaborate",       icon: "✉️", to: "/contact",      accent: "rose"   },
];

export default function Hero() {
  const cardRefs = useRef([]);
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const observers = cardRefs.current.map((el, i) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => setVisibleCards(prev => [...new Set([...prev, i])]), i * 60);
            obs.disconnect();
          }
        },
        { threshold: 0.1 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach(o => o?.disconnect());
  }, []);

  return (
    <div className="hero-root" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <div className="orb orb-1" />
      <div className="orb orb-2" />

      {/* ── Top bar ── */}
      <nav className="topbar">
        <Link to="/" className="topbar-logo">Dylan.Dev</Link>
        <ul className="topbar-links">
          <li><Link to="/projects">Projects</Link></li>
          <li><Link to="/resume">Resume</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>

      {/* ── Hero section ── */}
      <section className="hero-section">
        <div className="status-pill">
          <span className="status-dot" />
          Turning ideas into meaningful digital solutions
        </div>

        <div className="avatar-wrap">
          <div className="avatar-ring" />
          <div className="avatar-inner">
            {<img src="/1000062748.jpeg" alt="Dylan Jeremy Malipol" />}
          </div>
        </div>

        <h1 className="hero-name">
          Dylan <span className="accent">Jeremy </span>Malipol
        </h1>

        <div className="hero-title">
          <span className="tag active">Computer Engineering Student</span>
          <span className="tag">Aspiring Software Developer</span>
        </div>

        <p className="hero-tagline">
          "Learning, building, and innovating through technology."
        </p>

        <div className="cta-group">
          <Link to="/projects" className="btn btn-primary">
            <span>🛠️</span> View Portfolio
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            <span>✉️</span> Contact Me
          </Link>
        </div>

        <div className="scroll-hint">
          <span className="scroll-line" />
          scroll to explore
        </div>
      </section>

      {/* ── Navigation grid ── */}
      <div className="section-label">
        <h2><span>◆</span> Explore My Portfolio</h2>
      </div>

      <div className="nav-grid">
        {NAV_CARDS.map((card, i) => (
          <Link
            key={card.to}
            to={card.to}
            className={`nav-card ${visibleCards.includes(i) ? "visible" : ""}`}
            data-accent={card.accent}
            ref={el => (cardRefs.current[i] = el)}
            style={visibleCards.includes(i) ? { transitionDelay: `${i * 40}ms` } : {}}
          >
            <div className="nav-icon">{card.icon}</div>
            <div>
              <div className="nav-card-label">{card.label}</div>
              <div className="nav-card-desc">{card.desc}</div>
            </div>
            <span className="nav-arrow">↗</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
